import React from 'react'
import "./CustomModal.css"
import { Button, Modal } from 'react-bootstrap'
function CustomModal(props) {
  console.log(props);
  
  return (
    <>
          <Modal
      {...props}
      size={props?.size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

    {props?.body}
  {props?.footer}
    </Modal>

    </>
  )
}

export default CustomModal
